import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Guest/Login/Header.svg'


const _hoisted_1 = {
  class: "container-fluid bg-header",
  id: "login"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row flex-column flex-lg-row align-items-center p-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "col col-lg-6 py-5 px-0 px-lg-5 transparent-input" }
const _hoisted_6 = { class: "text-start mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "Login", -1)
const _hoisted_8 = { class: "text-white" }
const _hoisted_9 = {
  action: "",
  id: "loginForm"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"form-floating mb-4\"><input type=\"email\" class=\"form-control text-white\" placeholder=\"Enter your email\" id=\"email\"><label for=\"email\" class=\"text-white\">Email Address</label></div><div class=\"form-floating mb-3\"><input type=\"password\" class=\"form-control text-white\" placeholder=\"Enter your email\" id=\"password\"><label for=\"password\" class=\"text-white\">Password</label></div><div class=\"text-start\"><a href=\"#\" class=\"text-lightgreen\" id=\"forgotPassword\">Forgot Password?</a></div><div class=\"form-check d-flex align-items-start gap-3 my-5\"><input type=\"checkbox\" class=\"form-check-input\" value=\"\" id=\"rememberMe\"><label for=\"rememberMe\" class=\"form-check-label text-white\">Remember me</label></div>", 4)
const _hoisted_14 = { class: "d-grid gap-3 d-md-flex justify-content-md-start" }
const _hoisted_15 = {
  type: "submit",
  class: "btn btn-lightgreen text-black fw-bold px-5 py-2 rounded-1",
  ref: "login"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(" Not signed up yet? "),
              _createVNode(_component_router_link, {
                to: "/register",
                class: "text-lightgreen",
                id: "register"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Register now!")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("form", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", _hoisted_15, " Login ", 512)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}